import React, { useEffect } from 'react';
import './DRMThankYou.css';
import { useNavigate } from 'react-router-dom';
import pidilite_logo from "../../Assets/Images/pidilite_logo.png";
import { FaCheckCircle } from 'react-icons/fa';

function DRMThankYou() {
    const navigate = useNavigate();

    // Auto-redirect to home or close after 10 seconds (optional)
    useEffect(() => {
        const timer = setTimeout(() => {
            // You can uncomment this to auto-navigate somewhere
            // navigate('/');
        }, 10000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="thankyou-container">
            <div className="thankyou-header">
                <img src={pidilite_logo} alt="Pidilite Logo" className="thankyou-logo" />
            </div>
            
            <div className="thankyou-content">
                <div className="success-icon">
                    <FaCheckCircle />
                </div>
                
                <h1 className="thankyou-title">Thank You!</h1>
                
                <p className="thankyou-message">
                    Your feedback has been successfully submitted. We appreciate your participation 
                    in the DRM meeting and value your insights.
                </p>

                <div className="thankyou-details">
                    <p>Your responses will help us improve future meetings and better serve you.</p>
                </div>

                <div className="thankyou-actions">
                    <p className="thankyou-note">
                        You can now close this window.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default DRMThankYou;
